import React, { useEffect, useState } from 'react'
import CommonTablePage from '../../../../../components/common/common-table/common-table-page'
import {urlKey, urlType} from '../../../../../services/api/api-urls'
import CommonDialog from '../../../../../components/common/others/common-dialog'
import {DispatchedColumnModel} from './dispatched-column-model'
import {ApiRequest} from '../../../../../services/api/api'
import SalesOrderProductManagementDialog
  from '../../../../order/sales-order/sales-order-product-management-dialog/sales-order-product-management-dialog'
import DispatchOrderDetailsTable from '../dispatch-order-details-table/dispatch-order-details-table'
import packingSlipPdfGenerate from '../../../../static/pdf/packing-slip/packing-slip-pdf-generate-all'
import SweetAlertService from '../../../../../services/lib/utils/sweet-alert-service'
import Iselect from "../../../../../components/common/i-select";
import moment, { months } from 'moment'
import { Button, DatePicker, Modal, Select, InputNumber, message, Table } from 'antd'
import { useDocumentTitle } from '../../../../../services/title/useDocumentTitle'
import PalletBarcodeModal from '../pallet-barcode-modal/pallet-barcode-modal'
import { getCookie } from 'react-use-cookie'

const { RangePicker } = DatePicker

const DispatchedTable = (props: {orderId: any,isPicking?: boolean}):any => {
  const [orderId, setOrderId] = useState<any>()
  const [selectOptions, setSelectOptions] = useState<any>([
    {value:1,label:'One months'},
    {value:2,label:'Three months'},
    {value:3,label:'One Year'}])

  const [selectedOption, setSelectedOption] = useState<any>();
  const [open, setOpen] = useState(false)
  const [dialogTitle, setDialogTitle] = useState<string>()
  const [products, setProducts] = useState<any>(null)
  const [triggerResetData, setTriggerResetData] = useState(false)
  const [dialogContent, setDialogContent] = useState<any>()

  // 托盘条形码对话框状态
  const [palletBarcodeVisible, setPalletBarcodeVisible] = useState(false);
  const [newPalletNos, setNewPalletNos] = useState<string[]>([]);

  // 托盘配置对话框状态
  const [palletConfigVisible, setPalletConfigVisible] = useState(false);
  const [selectedDispatchData, setSelectedDispatchData] = useState<any>(null);
  const [palletTypes, setPalletTypes] = useState<any[]>([]);
  const [selectedPalletType, setSelectedPalletType] = useState<number | null>(null);
  const [palletQuantity, setPalletQuantity] = useState<number>(1);
  const [existingPalletLog, setExistingPalletLog] = useState<any>(null); // 存储现有的托盘配置
  const [isUpdateMode, setIsUpdateMode] = useState(false); // 是否为更新模式

  const [startDate, setStartDate] = useState<any>(moment().add(-3,'months'))
  const [endDate, setEndDate] = useState<any>(moment())
  const [url, setUrl] = useState<any>("Dispatching/GetAllDispatching?start="
        + moment().add(-3,'months').format('YYYY/MM/DD')
        +'&end='+moment().add(1,'days').format('YYYY/MM/DD'))
  const onDialogClose = async (isModified: boolean, newDispatchingId?: any) => {
    setOpen(false)
    if (isModified) {
        if (newDispatchingId) {
        console.log(newDispatchingId)
        const confirmResult = await SweetAlertService.confirmMessage('Do you want to config tracking no and courier at the moment?')
        if (confirmResult) {
          const result = await ApiRequest({
            url: 'Dispatching/GetSingleDispatching?dispatchId=' + newDispatchingId,
            method: 'get',
            isShowSpinner: true
          })
          if (result) {
            openCompleteDialog(result.data.data)
          }
        }
      }
    }
    setTriggerResetData(!triggerResetData)    
  }
  //For automatic open new dispatch dialog
  const getIsPackingSlip = (() => {
    const pageUrl = window.location.pathname;
    return pageUrl == "/delivered";
  })

  const getIsOnBoard = (() => {
    const pageUrl = window.location.pathname;
    return pageUrl == "/OnBoard";
  })

    useDocumentTitle();
  useEffect(() => {
    // if (getIsPackingSlip()){
    //   document.title = "Delivered List"
    // } else if (getIsOnBoard()) {
    //   document.title = "On Board List"
    // } else{
    //   document.title = "To Be Delivered List"
    // }
    ApiRequest({
      url: 'Product/GetAllProduct?withOutStock=true',
      method: 'get',
      isShowSpinner: true
    }).then((e:any)=>{
      setProducts(e.data.data)
    })

    // 获取托盘类型列表
    ApiRequest({
      url: 'PlateType/GetAllPlateType',
      method: 'get',
      isShowSpinner: false
    }).then((e:any)=>{
      if (e?.data?.data) {
        console.log('Pallet types API response:', e.data.data)
        // 转换为Select组件期望的格式
        const formattedOptions = e.data.data.map((type: any) => ({
          value: type.plateTypeId,
          label: type.plateTypeName
        }))
        setPalletTypes(formattedOptions)
        console.log('Formatted pallet types:', formattedOptions)
      }
    }).catch((error) => {
      console.error('Failed to fetch pallet types:', error)
    })

    // 监听托盘配置事件
    const handlePalletConfig = async (event: any) => {
      const rowData = event.detail
      setSelectedDispatchData(rowData)
      setPalletConfigVisible(true)

      try {
        // 调用后台API获取现有的托盘配置
        const response = await ApiRequest({
          url: 'PalletStockLog/GetByDispatchId?dispatchId=' + rowData.dispatchId,
          method: 'get',
          isShowSpinner: true
        })

        if (response?.data?.data) {
          // 设置为更新模式
          setIsUpdateMode(true)
          setExistingPalletLog(response.data.data)

          // 填充表单数据
          setSelectedPalletType(response.data.data.plateTypeId || null)
          setPalletQuantity(response.data.data.quantity || 1)
        } else {
          // 没有现有配置，设置为新增模式
          setIsUpdateMode(false)
          setExistingPalletLog(null)
          setSelectedPalletType(null)
          setPalletQuantity(1)
        }
      } catch (error) {
        console.error('Failed to fetch pallet configuration:', error)
        // 如果获取失败，设置为新增模式
        setIsUpdateMode(false)
        setExistingPalletLog(null)
        setSelectedPalletType(null)
        setPalletQuantity(1)
      }
    }

    window.addEventListener('openPalletConfig', handlePalletConfig)

    // 监听 TrackingNo 修改成功事件，刷新列表
    const handleRefreshDispatchedTable = () => {
      setTriggerResetData(prev => !prev)
    }
    window.addEventListener('refreshDispatchedTable', handleRefreshDispatchedTable)

    return () => {
      window.removeEventListener('openPalletConfig', handlePalletConfig)
      window.removeEventListener('refreshDispatchedTable', handleRefreshDispatchedTable)
    }
  }, [])

  useEffect(() => {
    let isCancelled = false
    if (!orderId && props.orderId && !isCancelled) {
      setOrderId(props.orderId)
    }
    return () => {
      isCancelled = true
    }
    
  }, [props.orderId, orderId])

  const salesOrderProductManagementDialog = (orderData: any, dispatchData: any) => <SalesOrderProductManagementDialog isAwaitingDispatchPage={true} dispatchData={dispatchData} isNewOrder={false} onDialogClose={onDialogClose} orderData={orderData} />

  const dispatchOrderDetailsTable = (orderData: any, dispatchData: any) => <DispatchOrderDetailsTable onDialogClose={onDialogClose} dispatchData={dispatchData} orderId={orderData.orderId} />
  const getBlob = (filename:any,blob?:any) => {
    const blobURL = URL.createObjectURL(blob)
    let downloadlink  =document.createElement("a");
    downloadlink.href = blobURL;
    downloadlink.download =filename
    document.body.appendChild(downloadlink);
    downloadlink.click();
    document.body.removeChild(downloadlink);    
  }
 const pdfActionButton = [
    {
      icon: '',
      tooltip: '💾',
      position: 'row',
      // isFreeAction: false,
      onClick: async (event: any, rowData: any) => {
        // Fetch packaging information for products
        const uniqueProductIds = Array.from(new Set(rowData.dispatchingDetails.map((d: any) => d.box.product.productId)))
        const productPromises = uniqueProductIds.map((productId: any) =>
          ApiRequest({
            url: 'Product/GetProductById?id=' + productId,
            method: 'get',
            isShowSpinner: false
          })
        )
        const productResults = await Promise.all(productPromises)
        const productsMap = productResults.reduce((map: any, result: any) => {
          if (result?.data?.data) {
            map[result.data.data.productId] = result.data.data
          }
          return map
        }, {})

        // Merge packaging info into orderProduct
        const enrichedOrderProduct = rowData.order.orderProduct.map((op: any) => {
          const productDetail = productsMap[op.productId]
          if (productDetail) {
            return {
              ...op,
              product: productDetail
            }
          }
          return op
        })

        const carton = rowData.dispatchingDetails.map((res:any) => {
          return {
            productId: res.box.product.productId,
            product: res.box.product.productCode,
            quantity: res.quantity,
            description: res.box.product.productName,
            carton: rowData.dispatchingDetails.filter((res1:any) => res1.productId === res.productId &&
              res1.quantity === res.quantity).length
          }
        })

        const orderProductMap = rowData.order.orderProduct.reduce((map: any, obj: any, index: number) => {
          map[obj.productId] = index;
          return map;
        }, {});

        const sortedCarton = carton.sort((a: any, b: any) => {
          const aIndex = orderProductMap[a.productId];
          const bIndex = orderProductMap[b.productId];
          return aIndex - bIndex;
        });

        const sorted = groupBy(sortedCarton, function(item:any) {
          return [item.product,item.quantity]
        })

        const finalCarton = sorted.map((res:any) => {
          const sum = res.reduce((accumulator:any, currentValue:any) => accumulator + currentValue.quantity, 0)
          return arrayDeduplication(res).map((res:any) => {
            res.sum = sum
            return res
          });
        })
        const courier = rowData.courierName?rowData?.courierName:rowData.order?.deliveryMethod?.deliveryMethodName;
        if (!courier)  {
            SweetAlertService.errorMessage('No delivery method found for your order. Packing slip cannot be generated. Please contact admin for assistance.')
            return
        }
        const obj = {
          tableContent: finalCarton.flat(Infinity),
          customer: {...rowData.order, orderProduct: enrichedOrderProduct},
          deliveredAt: rowData.deliveredAt,
          courier:courier,
          packingSlipNo:rowData.packingSlipNo,
          employee:rowData.employee?.firstName,
          outstanding:rowData.dispatchingOutStanding,
          palletType:rowData?.palletStockLog?.length>0?rowData?.palletStockLog[0].plateType?.plateTypeName:null,
          palletTypeQty:rowData?.palletStockLog?.length>0?rowData?.palletStockLog[0]?.quantity:null,
        }
        console.log(obj);
        let filename = 'PS'+rowData.packingSlipNo+'_'+rowData.order?.customer?.customerCode;
        packingSlipPdfGenerate(obj,"getBlob",getBlob,filename)
      }
    }
  ]
  const newDispatch = async () => {
    const result = await ApiRequest({
      urlInfoKey: urlKey.SalesOrder,
      type: urlType.GetById,
      dataId: props.orderId,
      isShowSpinner: false
    })
    if (result) {
      setOpen(true)
      setDialogTitle('Locations - Create')
      setDialogContent(salesOrderProductManagementDialog(result.data.data, null))
    }
  }

  // 修改: OnBoard 按钮 - 支持批量操作
  const onBoardButton = {
    icon: '',
    tooltip: 'On Board',
    isFreeAction: false,  // 批量操作按钮，不是 row 按钮
    onClick: async (event: any, rowData: any) => {
      // 判断是单选还是多选
      const isMultiple = Array.isArray(rowData)
      const dataArray = isMultiple ? rowData : [rowData]
      
      // 检查是否所有选中的数据状态都是 1 或 4
      const invalidOrders = dataArray.filter((item: any) => item.status !== 1 && item.status !== 4)
      
      if (invalidOrders.length > 0) {
        SweetAlertService.errorMessage(
          isMultiple 
            ? `${invalidOrders.length} order(s) cannot be marked as On Board!`
            : "This order cannot be marked as On Board!"
        )
        return
      }
      
      const confirmed = await SweetAlertService.confirmMessage(
        isMultiple 
          ? `Are you sure you want to mark ${dataArray.length} order(s) as On Board?`
          : 'Are you sure you want to mark this as On Board?'
      )
      
      if (confirmed) {
        try {
          // 批量处理所有选中的订单
          const promises = dataArray.map((item: any) => 
            ApiRequest({
              url: 'Dispatching/OnBoard?id=' + item.dispatchId,
              method: 'put',
              isShowSpinner: false
            })
          )
          
          await Promise.all(promises)
          
          SweetAlertService.successMessage(
            isMultiple 
              ? `Successfully marked ${dataArray.length} order(s) as On Board!`
              : 'Successfully marked as On Board!'
          )
          setTriggerResetData(!triggerResetData)
        } catch (e) {
          SweetAlertService.errorMessage('Failed to mark as On Board')
        }
      }
    }
  }

  const actionButtons: any = [
    ...(props.isPicking
      ? []
      : [
          {
            icon: '',
            tooltip: 'Create new dispatch',
            isFreeAction: true,
            onClick: async (event: any, rowData: any) => {
              newDispatch();
            },
          },
        ]),
    {
      icon: '',
      tooltip: 'Delivered',
      position: 'row',
      onClick: async (event: any, rowData: any) => {
        if (rowData.status === 1 || rowData.status === 4) {
          await openCompleteDialog(rowData)
        } else {
          SweetAlertService.errorMessage("This order has already been Delivered!")
        }
      }
    },
    // 添加 OnBoard 按钮到 To Be Delivered 页面
    ...(!getIsPackingSlip() && !getIsOnBoard() ? [onBoardButton] : []),
    {
      icon: 'danger',
      tooltip: '🗙',
      position: 'row',
      onClick: async (event: any, rowData: any) => {
          const confirmed =await SweetAlertService.confirmMessage();
          if (confirmed){
              const result = await ApiRequest({
                url: 'Dispatching/DeleteDispatching?id=' + rowData.dispatchId,
                method: 'delete',
                isShowSpinner: true
              }
            )

            // 如果返回包含 newPalletNos，显示托盘条形码对话框
            if (result?.data?.data?.newPalletNos?.length > 0) {
              setNewPalletNos(result.data.data.newPalletNos)
              setPalletBarcodeVisible(true)
            } else {
              setTriggerResetData(!triggerResetData)
            }
          }
        }
      },    
    ...pdfActionButton,
  ]

  const openCompleteDialog = async (rowData: any) => {
    const result = await ApiRequest({
      urlInfoKey: urlKey.SalesOrder,
      type: urlType.GetById,
      dataId: rowData.orderId,
      isShowSpinner: false
    })
    if (result) {
      setOpen(true)
      setDialogTitle('Locations - Complete')
      setDialogContent(dispatchOrderDetailsTable(result.data.data, rowData))
    }
  }

  const actionButtons2 = [
    ...pdfActionButton
  ]

  const groupBy = (array:any, f:any) => {
    const groups:any = {}
    array.forEach(function(o:any) {
      const group = JSON.stringify(f(o))
      groups[group] = groups[group] || []
      groups[group].push(o)
    })
    return Object.keys(groups).map(function(group) {
      return groups[group]
    })
  }

  const arrayDeduplication = (arr:any) => {
    const result = []
    const obj:any = {}
    for (let i = 0; i < arr.length; i++) {
      if (!obj[arr[i].product]) {
        result.push(arr[i])
        obj[arr[i].product] = true
      }
    }
    return result
  }
  const findProductById = (id:number) =>{
    const product = products.find((product:any) => product.productId === id);
    if (product) {
      return product;
    } else {
      return null;
    }
  }
  const getRenderData = (data: any) => {
    let renderData: any[] = []
    data.map((row: any) => {
      row.order.orderProduct.map((row: any) => {
        row.product = findProductById(row.productId);
      })
      row.dispatchingDetails.map((row: any) => {
        row.box.product = findProductById(row.box.productId); 
      })
      row.dispatchingOutStanding.map((row: any) => {
        row.product = findProductById(row.productId); 
      })
              // const courier = rowData.courierName?rowData?.courierName:rowData.order?.deliveryMethod?.deliveryMethodName;

      row.status && renderData.push({
        ...row,
        customerStr: row.order?.customer?.customerCode,
        courierName: row.courier?.courierName,
        deliveryMethodName:row.order?.deliveryMethod?.deliveryMethodName,
        createdAt1: row.createdAt,
        createdAt: row.createdAt && (new Date(row.createdAt + '.000Z')).toLocaleString(),
        custOrderNo:row.order?.custOrderNo
      })
    })
    console.log(renderData)
    if (props.orderId) return renderData
    renderData = renderData.filter((row:any)=>{
      if (getIsPackingSlip()) return row.status == 2
      if (getIsOnBoard()) return row.status == 4
      return row.status == 1
    })
    return renderData
  }

  const setUrlforChange = (value:any) => {
    let url = 'Dispatching/GetAllDispatching';
    if (orderId){
      url = 'Dispatching/GetAllDispatching?orderId=' + orderId
      setUrl(url);
      return
    }
    if (value){
      let startDate,endDate;
      endDate = moment().add(1,'days').format('YYYY/MM/DD');
      if (value==1){
        startDate=moment().add(-1,'months').format('YYYY/MM/DD');
      }
      else if (value==2){
        startDate=moment().add(-3,'months').format('YYYY/MM/DD');
      }
      else if (value==3){
        startDate=moment().add(-1,'years').format('YYYY/MM/DD');
      }
      url = 'Dispatching/GetAllDispatching?start=' + startDate+'&end='+endDate
    }    
    setUrl(url);
  }
  const sourceSelectHandle =(value:any) =>{
    setUrlforChange(value);
    setTriggerResetData(!triggerResetData)
  }

  const onChangeDateRange = (value: any) => {
    setStartDate(value?value[0]:null)
    setEndDate(value?value[1]:null)
    let url = 'Dispatching/GetAllDispatching'
    if (orderId) {
      url = 'Dispatching/GetAllDispatching?orderId=' + orderId
      setUrl(url)
      setTriggerResetData(!triggerResetData)
      return
    }
    if (value && value.length === 2) {
      url = 'Dispatching/GetAllDispatching' + '?start=' + value[0].format('YYYY/MM/DD') + '&end=' + value[1].format('YYYY/MM/DD')
    }
    setUrl(url)
    setTriggerResetData(!triggerResetData)
  }
  const onClearDateRange = () => {
    setStartDate(null)
    setEndDate(null)
    setUrl('Dispatching/GetAllDispatching?start='
      + moment().add(-1,'months').format('YYYY/MM/DD')
      +'&end='+moment().add(1,'days').format('YYYY/MM/DD'))
    setTriggerResetData(!triggerResetData)
  }

  // 处理托盘条形码对话框关闭
  const handlePalletBarcodeClose = () => {
    setPalletBarcodeVisible(false)
    setNewPalletNos([])
    setTriggerResetData(!triggerResetData)
  }

  // 保存托盘配置
  const handleSavePalletConfig = async () => {
    if (!selectedPalletType) {
      message.error('Please select a pallet type')
      return
    }

    if (palletQuantity < 1) {
      message.error('Quantity must be at least 1')
      return
    }

    try {
      if (isUpdateMode && existingPalletLog) {
        // 更新模式 - 调用UpdateByDispatchId
        await ApiRequest({
          url: 'PalletStockLog/UpdateByDispatchId',
          method: 'put',
          data: {
            dispatchId: selectedDispatchData.dispatchId?.toString(),
            plateTypeId: selectedPalletType,
            quantity: palletQuantity,
            employeeId: parseInt(getCookie('id') || '0'),
            notes: `Updated pallet configuration for dispatch ${selectedDispatchData.packingSlipNo}`,
            // 如果需要传递logId，可以添加
            logId: existingPalletLog.logId
          },
          isShowSpinner: true
        })
        message.success('Pallet configuration updated successfully')
      } else {
        // 新增模式 - 调用Add
        await ApiRequest({
          url: 'PalletStockLog/Add',
          method: 'post',
          data: {
            dispatchId: selectedDispatchData.dispatchId?.toString(),
            plateTypeId: selectedPalletType,
            quantity: palletQuantity,
            employeeId: parseInt(getCookie('id') || '0'),
            notes: `Pallet configuration for dispatch ${selectedDispatchData.packingSlipNo}`
          },
          isShowSpinner: true
        })
        message.success('Pallet configuration created successfully')
      }

      setPalletConfigVisible(false)
      setTriggerResetData(!triggerResetData)
    } catch (error) {
      message.error('Failed to save pallet configuration')
    }
  }

  // 处理托盘配置对话框关闭
  const handlePalletConfigClose = () => {
    setPalletConfigVisible(false)
    setSelectedDispatchData(null)
    setSelectedPalletType(null)
    setPalletQuantity(1)
    setExistingPalletLog(null)
    setIsUpdateMode(false)
  }

  // 删除托盘配置
  const handleDeletePalletConfig = async () => {
    if (!existingPalletLog) return

    try {
      // 显示确认对话框
      const confirmed = await SweetAlertService.confirmMessage('Are you sure you want to delete this pallet configuration?')

      if (!confirmed) {
        return
      }

      // 调用删除API
      await ApiRequest({
        url: 'PalletStockLog/Delete?id=' + existingPalletLog.logId,
        method: 'delete',
        isShowSpinner: true
      })

      message.success('Pallet configuration deleted successfully')

      // 关闭对话框并刷新数据
      setPalletConfigVisible(false)
      setSelectedDispatchData(null)
      setSelectedPalletType(null)
      setPalletQuantity(1)
      setExistingPalletLog(null)
      setIsUpdateMode(false)
      setTriggerResetData(!triggerResetData)
    } catch (error) {
      message.error('Failed to delete pallet configuration')
    }
  }

  // 选择变化回调
  const onSelectionChange = (newRows: any) => {
    console.log('Selected rows:', newRows)
    // 可以在这里处理选中的行，例如保存到 state
  }

  // 判断是否显示在 To Be Delivered 页面（可以多选）
  const isToBeDeliveredPage = !getIsPackingSlip() && !getIsOnBoard()

  return (
    <div style={{position:'relative'}}>
      {!orderId &&<div style={{position:'absolute',marginTop:'20px',marginLeft:'400px',zIndex:10, display: 'flex'}}>
        <RangePicker value={[startDate, endDate]} onChange={onChangeDateRange}/>
        <div ><Button type="primary" onClick={onClearDateRange} 
          style={{marginLeft:'20px'}}>
          Clear Date</Button>
        </div>
      </div>}
      {
        (props.orderId) ? (
          products&&<div>
            <CommonTablePage
              urlInfoKey={urlKey.Dispatch}
              getAllUrl={'Dispatching/GetAllDispatching?orderId=' + props.orderId}
              title={'Dispatched table'}
              column={DispatchedColumnModel().map((row: any) => {
                return row
              }).filter((row: any) => {
                return row.title!='Customer'&& row.title!='Po Number' && row.field!='imgs'
              })
            }
              mappingRenderData={(data: any) => getRenderData(data)}
              actionButtons={actionButtons.filter((e:any)=>{return e.tooltip!='Delivered' && e.tooltip!=='On Board'})}
              isNotEditable={true}
              isNotAddable={true}
              isNotDeletable={true}              
              triggerResetData={triggerResetData}
            />
          
          </div>
        ) : (
          products&&<CommonTablePage
          urlInfoKey={urlKey.Dispatch}
          getAllUrl={url}
            title={getIsPackingSlip() ? 'Delivered List' : getIsOnBoard() ? 'On Board List' : 'To Be Delivered list'}
            column={DispatchedColumnModel()
              .filter((row: any) => {
                // 如果不是 Packing Slip，而且是 imgs 就隐藏
                if (!getIsPackingSlip() && row.field === "imgs") {
                  return false;
                }

                // ❗ 新增逻辑：On Board List 或 To Be Delivered list 都隐藏 deliveredAt
                const title = getIsPackingSlip()
                  ? 'Delivered List'
                  : getIsOnBoard()
                  ? 'On Board List'
                  : 'To Be Delivered list';

                if (
                  (title === 'On Board List' || title === 'To Be Delivered list') &&
                  row.field === "deliveredAt"
                ) {
                  return false;
                }

                return true;
              })
              .map((row: any) => {
                if (row.title === 'Location') {
                  row.defaultFilter = ['2'];
                }

                if (row.title === 'Status') {
                  row.defaultFilter = getIsPackingSlip()
                    ? ['2']
                    : getIsOnBoard()
                    ? ['4']
                    : ['1'];
                }
                return row;
              })}
            actionButtons={
              getIsOnBoard() 
                ? actionButtons.filter((e:any)=>{return e.tooltip=='Delivered' || e.tooltip=='💾'})
                : (getIsPackingSlip()?actionButtons2:actionButtons.filter((e:any)=>{return e.tooltip!='Create new dispatch'}))
            }
            mappingRenderData={(data: any) => getRenderData(data)}
            isNotEditable={true}
            isNotAddable={true}
            isNotDeletable={true}
            triggerResetData={triggerResetData}
            // 只在 To Be Delivered 页面启用多选
            isEnableSelect={isToBeDeliveredPage}
            onSelectionChange={isToBeDeliveredPage ? onSelectionChange : undefined}

          />
          
        )
        
      }
        <CommonDialog title={dialogTitle} open={open} onDialogClose={onDialogClose} dialogContent={dialogContent} />
        <PalletBarcodeModal
          visible={palletBarcodeVisible}
          onClose={handlePalletBarcodeClose}
          palletNos={newPalletNos}
        />

        {/* 托盘配置对话框 */}
        <Modal
          title={isUpdateMode ? 'Update Pallet Configuration' : 'Pallet Configuration'}
          open={palletConfigVisible}
          width={500}
          footer={
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                {/* Delete button - only visible in Update mode */}
                {isUpdateMode && existingPalletLog && (
                  <Button
                    danger
                    onClick={handleDeletePalletConfig}
                  >
                    Delete
                  </Button>
                )}
              </div>
              <div>
                <Button style={{ marginRight: 8 }} onClick={handlePalletConfigClose}>
                  Cancel
                </Button>
                <Button type="primary" onClick={handleSavePalletConfig}>
                  {isUpdateMode ? 'Update' : 'Save'}
                </Button>
              </div>
            </div>
          }
        >
          <div style={{ padding: '20px 0' }}>
            <div style={{ marginBottom: '16px' }}>
              <div style={{ marginBottom: '8px', fontWeight: 500 }}>
                Packing Slip No:
              </div>
              <div>{selectedDispatchData?.packingSlipNo || '-'}</div>
            </div>

            {/* 显示现有配置信息 */}
            {/* {isUpdateMode && existingPalletLog && (
              <div style={{
                marginBottom: '16px',
                padding: '12px',
                backgroundColor: '#f0f9ff',
                border: '1px solid #91d5ff',
                borderRadius: '6px'
              }}>
                <div style={{ fontSize: '13px', fontWeight: 600, color: '#0050b3', marginBottom: '8px' }}>
                  Current Configuration:
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  <div style={{ marginBottom: '4px' }}>
                    <span style={{ fontWeight: 500 }}>Type:</span> {
                      palletTypes.find(t => t.value === existingPalletLog.plateTypeId)?.label || '-'
                    }
                  </div>
                  <div style={{ marginBottom: '4px' }}>
                    <span style={{ fontWeight: 500 }}>Quantity:</span> {existingPalletLog.quantity || '-'}
                  </div>
                  {existingPalletLog.notes && (
                    <div>
                      <span style={{ fontWeight: 500 }}>Notes:</span> {existingPalletLog.notes}
                    </div>
                  )}
                </div>
              </div>
            )} */}

            <div style={{ marginBottom: '16px' }}>
              <div style={{ marginBottom: '8px', fontWeight: 500 }}>
                Pallet Type <span style={{ color: '#ff4d4f' }}>*</span>:
              </div>
              <Select
                style={{ width: '100%' }}
                placeholder="Select pallet type"
                value={selectedPalletType}
                onChange={(value) => setSelectedPalletType(value)}
                options={palletTypes.map((type: any) => ({
                  label: type.label,
                  value: type.value
                }))}
              />
            </div>

            <div style={{ marginBottom: '16px' }}>
              <div style={{ marginBottom: '8px', fontWeight: 500 }}>
                Quantity <span style={{ color: '#ff4d4f' }}>*</span>:
              </div>
              <InputNumber
                style={{ width: '100%' }}
                min={1}
                max={100}
                value={palletQuantity}
                onChange={(value) => setPalletQuantity(value || 1)}
                placeholder="Enter quantity"
              />
            </div>
          </div>
        </Modal>
    </div>
  )
}

export default DispatchedTable
